enum CommunicationsStatus {
  READED = 'READED',
  CREATED = 'CREATED',
}

export { CommunicationsStatus };
